<template>
  <div>
    <v-dialog v-model="error" width="500">
      <v-card>
        <v-card-title class="headline red accent-3" primary-title>
          Warning Message
        </v-card-title>

        <v-card-text>
          {{ errorMsg }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red accent-3" flat @click="setErrorZero">close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div>
      <v-snackbar
        v-model="snackbar"
        :right="x === 'right'"
        :timeout="timeout"
        :top="y === 'top'"
      >
        {{ errorMsg }}
        <v-btn color="pink" flat @click="snackbar = false">Close</v-btn>
      </v-snackbar>
    </div>

    <v-toolbar flat color="white">
      <v-toolbar-title>Url To Role</v-toolbar-title>
    </v-toolbar>
    <v-card>
      <v-card-text>
        <v-layout row>
          <v-spacer></v-spacer>
          <v-container grid-list-md>
            <v-layout row>
              <v-flex xs12 sm6 md4>
                <v-select
                  v-model="editedItem.role_id"
                  :items="indexData.roles"
                  item-text="name"
                  item-value="id"
                  box
                  label="Select Role"
                ></v-select>
                <v-btn color="blue darken-1" flat @click="show">Show</v-btn>
                <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
              </v-flex>
              <v-flex xs12 sm6 md4 ml-5>
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Search By Group"
                  single-line
                  hide-details
                  align="center"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-spacer></v-spacer>
          </v-container>
        </v-layout>
      </v-card-text>
    </v-card>

    <div v-if="loadData">
      <v-data-table
        v-model="editedItem.urls_id"
        :headers="urlHeaders"
        :items="indexData.urls"
        item-key="id"
        :search="search"
        select-all
        class="elevation-1"
        show-select
        hide-actions
      >
        <template v-slot:items="propsUrl">
          <td>
            <v-checkbox
              v-model="propsUrl.selected"
              selected
              primary
              hide-details
            ></v-checkbox>
          </td>
          <td class="text-xs-left">{{ propsUrl.item.id }}</td>
          <td class="text-xs-left">{{ propsUrl.item.name }}</td>
          <td class="text-xs-left">{{ propsUrl.item.url_group }}</td>
          <td class="text-xs-left">{{ propsUrl.item.url }}</td>
          <td class="text-xs-left">{{ propsUrl.item.operation }}</td>
          <td class="text-xs-left">{{ propsUrl.item.action_type }}</td>
        </template>
      </v-data-table>
      <v-layout row v-if="indexData.assignedUrlsToRole">
        <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat @click="save">Save</v-btn>
      </v-layout>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from "vuex";

  export default {
    data: () => ({
      dialog: false,
      search: "",
      snackbar: false,
      y: "top",
      x: "right",
      timeout: 4000,
      apiUrl: "url-to-role",
      urlHeaders: [
        { text: "ID", align: "left", value: "id", sortable: true },
        { text: "Url Name", align: "left", value: "name", sortable: false },
        { text: "Group", align: "left", value: "url_group", sortable: true },
        { text: "Url", align: "left", value: "name", sortable: false },
        { text: "Operation", align: "left", value: "operation", sortable: false },
        { text: "Action Type", align: "left", value: "action_type", sortable: false },
      ],
      editedIndex: -1,
      previousData: [],
      editedItem: {
        urls_id: [],
        url_id: "",
        role_id: "",
        url: {
          title: "",
          url: "",
        },
        role: {
          title: "",
        },
      },
      defaultItem: {
        previousData: [],
        urls_id: [],
        url_id: "",
        role_id: "",
        url: {
          title: "",
          url: "",
        },
        role: {
          title: "",
        },
      },
    }),

    computed: {
      ...mapGetters([
        "isLoggedIn",
        "indexData",
        "error",
        "statusCode",
        "errorMsg",
      ]),
      formTitle() {
        return this.editedIndex === -1
          ? "Assign Url To Role"
          : "Edit Url To Role";
      },
      loadData() {
        if (this.indexData.assignedUrlsToRole) {
          // console.log(this.indexData.assignedUrlsToRole);
          // this.editedItem.selected = this.previousData;
          // console.log(this.indexData.assignedUrlsToRole);
          return this.getSelected();
        } else {
          return false;
        }
      },
    },

    watch: {
      dialog(val) {
        val || this.close();
      },
    },

    created() {
      this.initialize();
    },

    methods: {
      initialize() {
        this.$store.dispatch("setIndexData", [this.apiUrl]);
      },
      getSelected() {
        this.editedItem.urls_id = this.indexData.assignedUrlsToRole;
        return true;
      },

      setErrorZero() {
        this.$store.dispatch("setErrorZero");
      },

      editItem(item) {
        this.editedIndex = this.indexData.urlToRoles.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
      },

      deleteItem(item) {
        const index = this.indexData.urlToRoles.indexOf(item);
        var result =
          confirm("Are you sure you want to delete this item?") &&
          this.indexData.urlToRoles.splice(index, 1);
        if (result) {
          this.$store.dispatch("delete", [this.apiUrl, item.id]);
          this.initialize();
        }
      },

      close() {
        this.dialog = false;
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        }, 300);
      },

      show() {
        // console.log(this.editedItem.role_id);
        if (this.editedIndex > -1) {
          this.$store.dispatch("indexData", [
            "assign-urls-to-role",
            this.editedItem.role_id,
          ]);
        } else {
          this.$store.dispatch("indexData", [
            "assign-urls-to-role",
            this.editedItem.role_id,
          ]);
        }
      },
      save() {
        // console.log(this.editedItem.selected)
        // console.log(this.indexData.assignedUrlsToRole)
        if (this.editedIndex > -1) {
          this.$store.dispatch("storeOrUpdate", [this.apiUrl, this.editedItem]);
        } else {
          this.$store.dispatch("storeOrUpdate", [this.apiUrl, this.editedItem]);
        }
        this.snackbar = true;
        this.close();
      },
    },
  };
</script>
<style scoped>
  .tbl-border {
    border: 1px solid #000;
  }
  .table-th {
    border: 1px solid #000;
  }
</style>
